import { ConflictError } from "./conflict-error";

// Thrown when a return is booked in an organisation that has no `receiving` warehouse zone. Every
// put-away leg starts at the goods-in door, so without one there is no origin to raise it from.
//
// `one_receiving_zone_per_org` makes that zone singular rather than mandatory — an organisation has
// one or none — so this is the "none" case, and it is configuration rather than a bad request: the
// warehouse names its Warenannahme once and every return afterwards works. Hence 409.
export class NoReceivingZoneError extends ConflictError {
	constructor() {
		super("stock.no_receiving_zone");
		this.name = "NoReceivingZoneError";
	}
}
